module.exports = __webpack_public_path__ + "img/Manage-Pre.457499fb.jpg";